
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "deleteAreaOnScenario",
      resolverType: "mutation",
      routePath: "/deleteAreaOnScenario",
      httpMethod: "POST",
    });
  